/**
 * Remove o foco do input numerico ao rolar o scroll, evitando alteracao acidental do valor.
 * Comportamento padrao do browser: wheel em <input type="number"> focado incrementa/decrementa.
 */
export const handleNumberInputWheel = (event) => {
  event.currentTarget.blur();
};
